// ===== Routes =====
export const ROUTE_PATHS = {
  HOME: '/',
} as const;

// ===== Types =====
export interface SpeciesFact {
  icon: string;
  label: string;
  value: string;
}

export interface ThreatItem {
  title: string;
  description: string;
  severity: 'high' | 'medium';
}

export interface GalleryImage {
  url: string;
  alt: string;
  caption: string;
}

// ===== Constants =====
export const SPECIES_FACTS: SpeciesFact[] = [
  { icon: '📏', label: '体长', value: '50 – 64 cm' },
  { icon: '🦴', label: '体重', value: '3.7 – 6.2 kg' },
  { icon: '🌍', label: '分布', value: '喜马拉雅东部 · 中国西南' },
  { icon: '🎋', label: '主食', value: '竹叶 · 竹笋' },
  { icon: '🌲', label: '栖息地', value: '温带山地森林' },
  { icon: '🌙', label: '活动时间', value: '晨昏型动物' },
];

export const THREATS: ThreatItem[] = [
  {
    title: '栖息地丧失',
    description: '人类毁林开荒、开矿采煤、道路建设，导致大量森林遭受破坏，令小熊猫的生存空间大大缩减。',
    severity: 'high',
  },
  {
    title: '非法捕猎与贸易',
    description: '因独特的外形而遭到猎捕，被用于皮毛交易及非法宠物贸易，对野生种群造成直接威胁。',
    severity: 'high',
  },
  {
    title: '气候变化',
    description: '全球变暖导致竹林退缩、山地温度升高，使小熊猫适宜栖息的高海拔地带逐渐缩小。',
    severity: 'medium',
  },
  {
    title: '近亲繁殖风险',
    description: '栖息地碎片化使种群相互隔离，基因交流减少，导致遗传多样性下降，削弱物种存续能力。',
    severity: 'medium',
  },
];

export const GALLERY_IMAGES: GalleryImage[] = [
  {
    url: 'https://images.unsplash.com/photo-1538099130811-745e64318258?w=800&q=80',
    alt: '小熊猫特写',
    caption: '好奇的眼神',
  },
  {
    url: 'https://images.unsplash.com/photo-1530048265464-939ec434a884?w=800&q=80',
    alt: '小熊猫全身照',
    caption: '蓬松的红褐色毛发',
  },
  {
    url: 'https://images.unsplash.com/photo-1600094329163-a2b52f913831?w=800&q=80',
    alt: '树上的小熊猫',
    caption: '天生的攀爬好手',
  },
  {
    url: 'https://images.unsplash.com/photo-1587543530169-2de7d1f2dcc7?w=800&q=80',
    alt: '懒洋洋的小熊猫',
    caption: '悠闲的午后时光',
  },
  {
    url: 'https://images.unsplash.com/photo-1707097620824-adcdf3e6df34?w=800&q=80',
    alt: '树梢上的小熊猫',
    caption: '居高临下望世界',
  },
  {
    url: 'https://images.unsplash.com/photo-1715883436095-a1c883e7d18e?w=800&q=80',
    alt: '吃竹子的小熊猫',
    caption: '竹林间的美食家',
  },
];

export const BEHAVIORS = [
  {
    emoji: '🎋',
    title: '竹食专家',
    description: '虽是杂食性动物，但竹叶和竹笋占据了小熊猫饮食的绝大部分，它们拥有特化的腕骨结构——类似"假拇指"，帮助握持竹茎。',
  },
  {
    emoji: '🌲',
    title: '树栖高手',
    description: '擅长攀爬，长而蓬松的尾巴在树梢间保持平衡。白天多在树上休息，用尾巴缠绕身体御寒，宛如一条红棕色的温暖围巾。',
  },
  {
    emoji: '🦊',
    title: '独行侠',
    description: '除繁殖期外，小熊猫基本独自生活，用气味腺标记领地。它们行事低调，在晨昏时分才会四处活动。',
  },
  {
    emoji: '❄️',
    title: '山地居民',
    description: '栖息于海拔 1500–4800 米的温带山地森林，喜欢气候凉爽湿润的环境，中国四川、云南及尼泊尔等地是其核心家园。',
  },
];
